import React, { Component } from "react";
import { Fade, FormGroup, FormControl, ControlLabel } from "react-bootstrap";
import LoaderButton                  from "../../components/LoaderButton";
import config                        from "../../config";
import { invokeApig, s3Upload }      from "../../libs/awsLib";
import { invokeSetCreateNewProgram } from "../../utils/AwsInvoke";
import ModalAlert                    from "../../components/modal/ModalAlert";
import "../../css/program/ProgramNew.css";

export default class ProgramNew extends Component {
    constructor(props) {
        super(props);

        this.file = null;

        this.state = {
          isLoading: null,
          title: "",
          open: false,
          showModalAlert:      false, // true | false
          clientId: `${this.props.match.params.client_id}`,
          clientName: `${this.props.match.params.client_name}`
        };
    }

    componentDidMount () {
        this.setState({
             open: true
        })
    }

    validateForm() {
        return this.state.title.length > 0;
    }

    ////   SHOW THE ALERT MODAL   ////
    setModalAlertProps = (title_text, body_text, show_modal) => {
        var alert_object = {};
        var alert_action = "";

        this.setState({
            modalAlertTitleText: title_text,
            modalAlertBodyText:  body_text,
            showModalAlert:      show_modal, // true | false
            alertObject:         alert_object,
            alertAction:         alert_action
        })
    }

    handleChange = event => {

        var text      = event.target.value;
        var check_str = text.includes("/");

        if(check_str) {
            var title_text = "Info"
            var body_text  = "Sorry, you can't add a '/' to the program title.";
            this.setModalAlertProps(title_text, body_text, true); // title_text, body_text, show_modal

            return false;
        }

        this.setState({
            title: event.target.value
        });
    }

    onKeyPress = event => {
        if(event.key === "Enter")
            this.submitProgramName();
    }

    handleFileChange = event => {
        this.file = event.target.files[0];
    }

    handleCancel = event => {
        event.preventDefault();

        //this.props.history.push("/");
        this.props.history.push("/programs/list");
    }

    handleSubmit = event => {
        event.preventDefault();

        this.submitProgramName();
    }

    submitProgramName = async event => {
        this.setState({ isLoading: true });

        try {
            var title       = this.state.title;
            var client_id   = this.state.clientId;
            var client_name = this.state.clientName;
            var is_template = true;

            if(client_id != 0) is_template = false;

            const results = await invokeSetCreateNewProgram(title, client_id, is_template);

            if(results.status) {
                var href = "/programs/detail/"+results.program_id+"/"+is_template+"/0/0"; // client name = 0 AND client_id = 0
                if(client_id != 0) href = "/client/detail/"+results.program_id+"/false/"+client_name+"/"+client_id;
                this.props.history.push(href);
            }
        } catch (e) {
          alert(e);
          this.setState({ isLoading: false });
        }
    }

    render() {
        var client_id = this.state.clientId;
        var client_name = this.state.clientName;
        var title     = "Template";
        var custom    = "";
        if(client_id != 0) title = "Program"
        if(client_name != 0) custom = client_name + "'s"
        let closeModalAlert           = () => this.setState({ showModalAlert: false }); //close simple modal window

        return (
            <Fade in={this.state.open}>
                  <div className="NewNote">
                      <br/>
                      <span className="title">
                          Name {custom} New {title}:
                      </span>
                      <form onSubmit={this.handleSubmit} className="form">
                              <input type="text"
                                     autoFocus
                                     placeholder = { title + " Name" }
                                     value       = {this.state.title}
                                     onKeyPress  = {this.onKeyPress.bind()}
                                     onChange    = {this.handleChange}
                                     className   = "input-lg titleField" />

                      { /* }<FormGroup controlId="file">
                        <ControlLabel>Attachment</ControlLabel>
                        <FormControl onChange={this.handleFileChange} type="file" />
                      </FormGroup> */ }

                      <div className="btnContainer">
                          <LoaderButton
                              btncolor  = "#ccc"
                              height    = {38}
                              width     = {150}
                              style     = {{height:38, width:150, color: "black"}}
                              type      = "submit"
                              text      = "Cancel"
                              loadingText = "Cancelling …"
                              onClick     = {this.handleCancel}
                              className   = "btnCancel"
                          />
                          &nbsp; &nbsp;
                          <LoaderButton
                              btncolor  = "#408fd2"
                              height    = {38}
                              width     = {150}
                              disabled  = {!this.validateForm()}
                              type      = "submit"
                              isLoading = {this.state.isLoading}
                              text      = "Create"
                              loadingText = "Creating …"
                              className = "btnNew"
                              onSubmit  = {this.handleSubmit}
                          />
                      </div>
                    </form>
                    {this.state.showModalAlert ?
                        <ModalAlert
                            onHide         = {closeModalAlert}
                            alertFunction  = {this.alertFunction}     // custom function to call within modal
                            alertAction    = {this.state.alertAction} // flag used for above function
                            alertObject    = {this.state.alertObject} // vars used for above function
                            showModalAlert = {this.state.showModalAlert}
                            messageTitle   = {this.state.modalAlertTitleText}
                            messageBody    = {this.state.modalAlertBodyText}
                        />
                    : null}
                  </div>
            </Fade>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/program/ProgramNew.js